<template>
    <v-container>
        <v-layout>
            <v-card width="100%" flat>


                    <v-container class="pa-5">
                        <v-flex offset-lg2 offset-md3 lg8 md6 xs12 align-center justify-space-between>
                            <v-card-title primary-title class="py-4 title">
                                Зарегистрировать тест
                            </v-card-title>


                                <v-container>
                                    <v-layout>
                                        <v-flex xs12 md12 mb-5 style="text-align: center">
                                            Введите код (ZK-XXXXXX-XXXXXX) с карточки без префикса ZK-
                                        </v-flex>
                                    </v-layout>

                                    <RegTestBare></RegTestBare>

                                </v-container>

                        </v-flex>
                    </v-container>


            </v-card>
        </v-layout>
    </v-container>
</template>

<script>
    import RegTestBare from "./RegTestBare"
    export default {
        components: {RegTestBare},
        name: "RegTest",
        data: () => ({}),
        watch: {},
        methods: {},
        computed: {}
    }
</script>
